/** Display size (px) for social icons in template builder and exported email HTML. */

export const SOCIAL_MEDIA_WIDGET_ICON_SIZE_MIN_PX = 24;
export const SOCIAL_MEDIA_WIDGET_ICON_SIZE_MAX_PX = 48;
export const SOCIAL_MEDIA_WIDGET_ICON_SIZE_STEP_PX = 2;
export const SOCIAL_MEDIA_WIDGET_DEFAULT_ICON_SIZE_PX = 36;

/** Spacing between social icons in preview and exported email HTML. */
export const SOCIAL_MEDIA_WIDGET_GAP_MIN_PX = 4;
export const SOCIAL_MEDIA_WIDGET_GAP_MAX_PX = 32;
export const SOCIAL_MEDIA_WIDGET_GAP_STEP_PX = 2;
export const SOCIAL_MEDIA_WIDGET_DEFAULT_GAP_PX = 12;

/** Legacy preview/email ratio: inner glyph / outer framed cell (14px icon in 28px frame). */
export const SOCIAL_MEDIA_FRAMED_INNER_ICON_RATIO = 14 / 28;

export function clampSocialMediaWidgetIconSizePx(raw: unknown): number {
  const min = SOCIAL_MEDIA_WIDGET_ICON_SIZE_MIN_PX;
  const max = SOCIAL_MEDIA_WIDGET_ICON_SIZE_MAX_PX;
  const step = SOCIAL_MEDIA_WIDGET_ICON_SIZE_STEP_PX;
  const defaultPx = SOCIAL_MEDIA_WIDGET_DEFAULT_ICON_SIZE_PX;

  const n = Number(raw);
  if (!Number.isFinite(n)) {
    return defaultPx;
  }

  const stepped = Math.round(n / step) * step;
  return Math.min(max, Math.max(min, stepped));
}

/**
 * Pixel size for the rendered SVG (email) or font-size (preview) for the glyph.
 * Same ratio as inside a framed cell (14px glyph in 28px frame), for all shapes including no frame,
 * so every brand/link icon scales consistently with the widget icon size.
 */
export function resolveSocialMediaInnerIconSizePx(outerSizePx: number): number {
  return Math.max(8, Math.round(outerSizePx * SOCIAL_MEDIA_FRAMED_INNER_ICON_RATIO));
}

export function clampSocialMediaWidgetGapPx(raw: unknown): number {
  const min = SOCIAL_MEDIA_WIDGET_GAP_MIN_PX;
  const max = SOCIAL_MEDIA_WIDGET_GAP_MAX_PX;
  const step = SOCIAL_MEDIA_WIDGET_GAP_STEP_PX;
  const defaultPx = SOCIAL_MEDIA_WIDGET_DEFAULT_GAP_PX;

  const n = Number(raw);
  if (!Number.isFinite(n)) {
    return defaultPx;
  }

  const stepped = Math.round(n / step) * step;
  return Math.min(max, Math.max(min, stepped));
}
